import { axiosPost } from '../ServiceBase.js';

export const findRecetasElectronicas = async (data) => {
  const recetas = await axiosPost('/v1/busquedas/receta-electronica/buscar', data);
  return recetas;
};
